export default __webpack_public_path__ + "static/media/information--end-of-minimum-speed-80--g1.e2f688b1.png";